module.exports = __webpack_public_path__ + "img/26.4afb1595.png";